<template>
  <div id="show-data">
    <h1 style="text-align:center;padding:40px 0px">数据集合</h1>
    <el-table :data="tableData" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="支出科目" width="180">
      </el-table-column>
      <el-table-column prop="type" label="批准预算数" width="180">
      </el-table-column>
      <el-table-column prop="name" label="截至2018年7月" width="180">
      </el-table-column>
      <el-table-column prop="pro" label="净结余" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">可将教学判断知识点进行智能分类的知识产权智慧交易平台关键技术研究项目销售收入台账</h3>
    <el-table :data="tableData2" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="数据项" width="180">
      </el-table-column>
      <el-table-column prop="type" label="完成金额" width="180">
      </el-table-column>
      <el-table-column prop="name" label="截至2018年7月" width="180">
      </el-table-column>
      <el-table-column prop="pro" label="净结余" width="180">
      </el-table-column>
    </el-table>
    <el-table :data="tableData3" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="培训单位数量" width="180">
      </el-table-column>
      <el-table-column prop="type" label="总金额" width="180">
      </el-table-column>
      <el-table-column prop="name" label="平均单位金额" width="180">
      </el-table-column>
      <el-table-column prop="pro" label="净结余" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">达到指标</h3>
    <el-table :data="tableData4" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="指标项" width="200">
      </el-table-column>
      <el-table-column prop="type" label="达成目标" width="560">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">自筹资金投入及使用情况</h3>
    <el-table :data="tableData5" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="指标项" width="200">
      </el-table-column>
      <el-table-column prop="type" label="达成目标" width="180">
      </el-table-column>
      <el-table-column prop="act" label="达成目标" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">自筹投入及使用情况</h3>
    <el-table :data="tableData5" style="width: 40%;margin:0px auto;">
      <el-table-column prop="date" label="指标项" width="200">
      </el-table-column>
      <el-table-column prop="type" label="达成目标" width="180">
      </el-table-column>
      <el-table-column prop="act" label="达成目标" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">可将教学视频片段按知识点进行智能分类的知识产权智慧交易平台关键技术研究项目经费支出情况总表</h3>
    <el-table :data="tableData6" style="width: 47.3%;margin:0px auto;">
      <el-table-column label="项目预算">
        <el-table-column prop="data2" label="合计" width="180">
        </el-table-column>
        <el-table-column prop="data3" label="自筹资金总额" width="180">
        </el-table-column>
        <el-table-column prop="data4" label="区资金总额" width="180">
        </el-table-column>
      </el-table-column>
      <el-table-column label="实际支出情况">
        <el-table-column prop="data5" label="合计" width="180">
        </el-table-column>
        <el-table-column prop="data6" label="自筹资金总额" width="180">
        </el-table-column>
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">可将教学视频片段按知识点进行智能分类的知识产权智慧交易平台关键技术研究项目总经费支出台账</h3>
    <el-table :data="tableData7" style="width: 86.5%;margin:0px auto;">
      <el-table-column prop="data1" label="课题负责人薪酬" width="200">
      </el-table-column>
      <el-table-column prop="data2" label="主要研究人员薪酬" width="180">
      </el-table-column>
      <el-table-column prop="data3" label="设备购置费" width="180">
      </el-table-column>
      <el-table-column prop="data4" label="材料费" width="180">
      </el-table-column>
      <el-table-column prop="data5" label="测试化验费" width="180">
      </el-table-column>
      <el-table-column prop="data6" label="会议差旅费" width="180">
      </el-table-column>
      <el-table-column prop="data7" label="项目管理费" width="180">
      </el-table-column>
      <el-table-column prop="data8" label="其他费用" width="180">
      </el-table-column>
      <el-table-column prop="data9" label="合计" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">可将教学视频片段按知识点进行智能分类的知识产权智慧交易平台关键技术研究项目区经费支出台账</h3>
    <el-table :data="tableData8" style="width: 86.5%;margin:0px auto;">
      <el-table-column prop="data1" label="课题负责人薪酬" width="200">
      </el-table-column>
      <el-table-column prop="data2" label="主要研究人员薪酬" width="180">
      </el-table-column>
      <el-table-column prop="data3" label="设备购置费" width="180">
      </el-table-column>
      <el-table-column prop="data4" label="材料费" width="180">
      </el-table-column>
      <el-table-column prop="data5" label="测试化验费" width="180">
      </el-table-column>
      <el-table-column prop="data6" label="会议差旅费" width="180">
      </el-table-column>
      <el-table-column prop="data7" label="项目管理费" width="180">
      </el-table-column>
      <el-table-column prop="data8" label="其他费用" width="180">
      </el-table-column>
      <el-table-column prop="data9" label="合计" width="180">
      </el-table-column>
    </el-table>
    <h3 style="text-align:center">可将教学视频片段按知识点进行智能分类的知识产权智慧交易平台关键技术研究项目区经费收入情况明细表</h3>
    <el-table :data="tableData9" style="width: 30%;margin:0px auto;">
      <el-table-column prop="data1" label="摘要" width="200">
      </el-table-column>
      <el-table-column prop="data2" label="金额" width="180">
      </el-table-column>
      <el-table-column prop="data3" label="入账科目" width="180">
      </el-table-column>
    </el-table>
    <div style="height:300px"></div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      tableData: [
        {
          date: "一、基建费",
          type: "----",
          name: "----",
          pro: "----"
        },
        {
          date: "二、人员费",
          type: "45.00",
          name: "45.00"
        },
        {
          date: "课题负责人",
          type: "10.00",
          name: "10.00"
        },
        {
          date: "主要研究人员",
          type: "35.00",
          name: "35.00"
        },
        {
          date: "三、设备费",
          type: "5.00",
          name: "4.95"
        },
        {
          date: "购置费",
          type: "5.00",
          name: "4.95"
        },
        {
          date: "试制费",
          type: "-----",
          name: "-----"
        },
        {
          date: "四、相关业务费",
          type: "35.00",
          name: "34.98"
        },
        {
          date: "材料费",
          type: "25.00",
          name: "24.81"
        },
        {
          date: "燃料费",
          type: "5.00",
          name: "4.95"
        },
        {
          date: "测试费",
          type: "5.00",
          name: "5.19"
        },
        {
          date: "会议差旅费",
          type: "5.00",
          name: "4.98"
        },
        {
          date: "五、项目管理费",
          type: "10.00",
          name: "9.76"
        },
        {
          date: "六、其他费用",
          type: "5.00",
          name: "5.66"
        },
        {
          date: "合计",
          type: "100.00",
          name: "100.35"
        }
      ],
      tableData2: [
        {
          date: "项目经济指标完成情况",
          type: "283.96万元"
        }
      ],
      tableData3: [
        {
          date: "26",
          type: "283.96万元",
          name: "10.9214万元"
        }
      ],
      tableData4: [
        {
          date: "首年聚集在线教育培训版权课件课时",
          type: "少于1000课时"
        },
        {
          date: "2018年上半年可收费试运营",
          type:
            "首年将增加教学视频交易服务约1.4万人次，增加服务收入310万元、利润总额122万元"
        },
        {
          date: "运营3年后达到设计的服务运营能力",
          type:
            "与2016年同比增加培训人员2.l万人，增加服务收入590万元、利润总额290万元"
        }
      ],
      tableData5: [
        {
          date: "项目自筹经费的预算金额",
          type: "220. 00万元",
          act: "219. 88万元"
        }
      ],
      tableData6: [
        {
          data1: "320. 00万元",
          data2: "220.00万元",
          data3: "100.00万元",
          data4: "320.23万元",
          data5: "219. 88万元",
          data6: "100.35万元"
        }
      ],
      tableData7: [
        {
          data1: "301580.42元",
          data2: "1055382.13元",
          data3: "200246.00元",
          data4: "861600.00元",
          data5: "154573.22元",
          data6: "140400.00元",
          data7: "251455.00元",
          data8: "237092.73元",
          data9: "3202293.50元"
        }
      ],
      tableData8: [
        {
          data1: "1000000.00元",
          data2: "350000.00元",
          data3: "49546.00元",
          data4: "248100.00元",
          data5: "51900.00元",
          data6: "49800.00元",
          data7: "97598.00元",
          data8: "56460.00元",
          data9: "1003504.00元"
        }
      ],
      tableData9: [
        {
          data1: "课题负责人",
          data2: "金额",
          data3: "入账科目"
        }
      ]
    };
  }
};
</script>
<style scoped>
</style>



